import { LazyQueryExecFunction } from '@apollo/client/react';

import {
  FormChecklistTemplate,
  FormChecklistTemplateFilterInputObject,
  FormChecklistTemplatesSearchListQuery,
  FormChecklistTemplatesSearchListQueryVariables,
  SortDirectionEnum,
} from 'graphql-common';
import { DEFAULT_SEARCH_LIST_VARIABLES } from '@lib/enums/urls';
import getLoadOptionsResult from '@lib/utils/getLoadOptionsResult';
import createSearchFilters, {
  defaultSearchListSchema,
} from '@lib/utils/createSearchFilters';
import { LoadOptionsParams } from '@lib/components/Select/types';

type FetchLazyQuery = LazyQueryExecFunction<
  FormChecklistTemplatesSearchListQuery,
  FormChecklistTemplatesSearchListQueryVariables
>;

export const fetchSearchList = async (
  searchQuery: string,
  fetchLazyQuery: FetchLazyQuery,
  page: number,
) => {
  const options: { variables: FormChecklistTemplatesSearchListQueryVariables } =
    {
      variables: {
        ...DEFAULT_SEARCH_LIST_VARIABLES,
        page,
        sorts: { name: SortDirectionEnum.Asc },
      },
    };
  const filters: FormChecklistTemplateFilterInputObject[] = [];
  if (searchQuery) {
    filters.push(...createSearchFilters(searchQuery, defaultSearchListSchema));
  }
  if (filters.length) {
    options.variables.filters = filters;
  }
  const { data } = await fetchLazyQuery(options);
  return getLoadOptionsResult(
    data,
    (dataItem: FormChecklistTemplate) => ({
      value: dataItem.id,
      label: dataItem.name,
    }),
    searchQuery,
  );
};

export const getFormChecklistsLoadOptions =
  (fetchLazyQuery: FetchLazyQuery) =>
  (searchQuery: string, loadedOptions: unknown, params: LoadOptionsParams) =>
    fetchSearchList(searchQuery, fetchLazyQuery, params?.page || 1);
